import React, { useEffect, useState } from "react";
import { Menu, X, Heart } from "lucide-react";
import { SITE, NAV_LINKS } from "../lib/site";
import { useSite } from "../lib/SiteContext";

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const { config } = useSite();
  const donateUrl = config.contact?.donate_url || SITE.donateUrl;

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 8);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const close = () => setOpen(false);

  return (
    <header
      data-testid="site-navbar"
      className={`sticky top-0 z-50 w-full transition-all duration-300 ${
        scrolled
          ? "backdrop-blur-xl bg-[#F9F7F4]/85 border-b border-[#E7E2DA]"
          : "bg-transparent"
      }`}
    >
      <div className="mx-auto max-w-7xl px-6 md:px-10 py-4 flex items-center justify-between">
        <a
          href="#top"
          data-testid="navbar-logo"
          className="flex items-center gap-2 group"
        >
          <span className="inline-flex h-9 w-9 items-center justify-center rounded-full bg-[#D85C41] text-white">
            <Heart className="h-4 w-4" strokeWidth={2.5} />
          </span>
          <span className="font-display text-lg md:text-xl font-extrabold tracking-tight text-[#1C1917]">
            {SITE.name}
          </span>
        </a>

        <nav className="hidden md:flex items-center gap-8">
          {NAV_LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
              className="text-sm font-medium text-[#57534E] hover:text-[#D85C41] transition-colors"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <a
            href={donateUrl}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="navbar-donate-btn"
            className="hidden sm:inline-flex items-center gap-2 rounded-full bg-[#1C1917] px-5 py-2.5 text-sm font-semibold text-[#F9F7F4] hover:bg-[#D85C41] transition-all duration-300 hover:-translate-y-0.5 shadow-sm"
          >
            <Heart className="h-3.5 w-3.5" strokeWidth={2.5} />
            Donate
          </a>
          <button
            data-testid="mobile-menu-toggle"
            onClick={() => setOpen((v) => !v)}
            className="md:hidden inline-flex h-10 w-10 items-center justify-center rounded-full border border-[#D6D3D1] bg-white"
            aria-label="Toggle menu"
          >
            {open ? <X className="h-5 w-5" /> : <Menu className="h-5 w-5" />}
          </button>
        </div>
      </div>

      {/* Mobile menu */}
      {open && (
        <div
          data-testid="mobile-menu"
          className="md:hidden border-t border-[#E7E2DA] bg-[#F9F7F4]"
        >
          <div className="px-6 py-5 flex flex-col gap-4">
            {NAV_LINKS.map((l) => (
              <a
                key={l.href}
                href={l.href}
                onClick={close}
                className="text-base font-medium text-[#1C1917] hover:text-[#D85C41]"
              >
                {l.label}
              </a>
            ))}
            <a
              href={donateUrl}
              target="_blank"
              rel="noopener noreferrer"
              onClick={close}
              className="inline-flex items-center justify-center gap-2 rounded-full bg-[#D85C41] px-5 py-3 text-sm font-semibold text-white"
            >
              <Heart className="h-3.5 w-3.5" strokeWidth={2.5} />
              Donate
            </a>
          </div>
        </div>
      )}
    </header>
  );
}
